import { Drawer, List, ListItem, Box, Typography } from "@mui/material";
import {
  KeyboardAltOutlined,
  StyleOutlined,
  LocalOffer,
  MapOutlined,
} from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { useDarkMode } from "../contexts/GlobalContext";

const drawerStyle = {
  width: 200,
  height: "fit-content",
  bgcolor: "primary.main",
  textAlign: "center",
  borderRadius: 1,
  padding: 2,
};

const TCDrawer = ({ open, onClose }) => {
  const darkMode = useDarkMode();
  const iconColor = darkMode ? "black" : "white";
  return (
    <Drawer open={open} onClose={onClose}>
      <List>
        <ListItem key='tag'>
          <RouterLink
            to='/tags'
            style={{ textDecoration: "none" }}
            onClick={onClose}>
            <Box sx={drawerStyle}>
              <Typography variant='h4' color='primary.contrastText'>
                Tags
              </Typography>
              <StyleOutlined sx={{ fontSize: 40, color: iconColor }} />
            </Box>
          </RouterLink>
        </ListItem>
        <ListItem key='codelegends'>
          <RouterLink
            to='/codelegends'
            style={{ textDecoration: "none" }}
            onClick={onClose}>
            <Box sx={drawerStyle}>
              <Typography variant='h4' color='primary.contrastText'>
                Code Legends
              </Typography>
              <KeyboardAltOutlined sx={{ fontSize: 40, color: iconColor }} />
            </Box>
          </RouterLink>
        </ListItem>
        <ListItem key='universalDescriptors'>
          <RouterLink
            to='/universalDescriptors'
            style={{ textDecoration: "none" }}
            onClick={onClose}>
            <Box sx={drawerStyle}>
              <Typography variant='h4' color='primary.contrastText'>
                Universal Descriptors
              </Typography>
              <LocalOffer sx={{ fontSize: 40, color: iconColor }} />
            </Box>
          </RouterLink>
        </ListItem>
        <ListItem key='bulkTagMapping'>
          <RouterLink
            to='/bulkTagMapping'
            style={{ textDecoration: "none" }}
            onClick={onClose}>
            <Box sx={drawerStyle}>
              <Typography variant='h4' color='primary.contrastText'>
                Bulk Tag Mapping
              </Typography>
              <MapOutlined sx={{ fontSize: 40, color: iconColor }} />
            </Box>
          </RouterLink>
        </ListItem>
      </List>
    </Drawer>
  );
};

export default TCDrawer;
